export default __webpack_public_path__ + "static/media/lemons-leaves-no-shadow@2x.b081c71a.png";